var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Validations = (function (Validations) {

		Validations.passwordStrength = function () {
			var value = arguments[0], config = arguments[1], score;

			if (config)
				score = Vendd.Helpers.textStrength(value);

			if (score >= config.limit)
				return true;

			return false;
        };

		return Validations;

	})(Vendd.Validations || {});

	return Vendd;

})(Vendd || {});